// extracted by mini-css-extract-plugin
export default {"formFooter":"AdminSSOUserCreationSettingCard-module__formFooter--x37st","provisionsField":"AdminSSOUserCreationSettingCard-module__provisionsField--CZDby"};